import { render, staticRenderFns } from "./SideDialogWindow.vue?vue&type=template&id=79882b9c&scoped=true"
import script from "./SideDialogWindow.ts?vue&type=script&lang=ts&external"
export * from "./SideDialogWindow.ts?vue&type=script&lang=ts&external"
import style0 from "./SideDialogWindow.scss?vue&type=style&index=0&id=79882b9c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79882b9c",
  null
  
)

export default component.exports